import { Buses_Bool_Exp } from "generated/graphql";
import { ScreeningView } from "types/screeningViewType";

export const maybeScreeningViewStatesFilter = (
    screeningViewData?: ScreeningView
): Buses_Bool_Exp => {
    return screeningViewData
        ? { state: { _in: screeningViewData.states } }
        : {};
};

export const maybeHideLockedBusesFilter = (
    hideLockedBuses: boolean
): Buses_Bool_Exp => {
    return {
        // If the user wants to hide locked buses, then we filter to buses that have an "unlocked"
        // attribute, as those are the ones that were unlocked by this user's team.
        ...(hideLockedBuses && {
            unlocked: {}
        })
    };
};

export const maybeOwnersFilter = (
    owners: readonly string[] | null
): Buses_Bool_Exp => {
    // null means all owners selected (no filter)
    if (owners === null) {
        return {};
    }
    // Empty array means no owners selected (show nothing)
    if (owners.length === 0) {
        return { owner_name: { _eq: "" } };
    }
    // Otherwise filter to selected owners
    return { owner_name: { _in: [...owners] } };
};
